export default class DividerTool {
  static get toolbox() {
    return {
      title: "Divider",
      icon: "<span class=\"icon-[lucide--minus] size-4\"></span>"
    }
  }

  render() {
    const wrapper = document.createElement("div")
    wrapper.className = "editorjs-divider-block"
    wrapper.innerHTML = "<hr class=\"editorjs-divider\" />"
    return wrapper
  }

  save() {
    return {}
  }
}
